import PageContent from './pageContent';

export default () => {
  return <PageContent />;
};
